import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Implementyeppy = () => {
  return (
    <div className="implement_yeppy p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h4>Implementation Plan</h4>
            <p>
              A well-structured implementation plan is crucial for efficient app
              development. Our roadmap includes milestones and timelines,
              detailing key development stages and timeframes. It guides project
              management and resource allocation, ensuring a smooth and
              on-schedule project progression.
            </p>
          </Col>
        </Row>
        <Row className="padd_top">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="imp_content">
              <h6>Research</h6>
              <p>
                We have identified what the target audience needs and what
                functions and features of the application they expect.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="imp_content">
              <h6>UX Design</h6>
              <p>
                We have achieved an optimal combination of functionality, ease
                of use, and aesthetic design of the application.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="imp_content">
              <h6>UI Design</h6>
              <p>
                We have achieved a visually appealing and intuitively
                understandable user interface of the application
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="imp_content">
              <h6>Development</h6>
              <p>
                We conducted testing to identify and fix any possible errors and
                issues in our mobile application
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="imp_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/imp_plan.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1181}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Implementyeppy;
